export default __webpack_public_path__ + "media/images/logo-2fe3858b.png";